import React from 'react';
import DashboardSummary from './dashboardsummary';

interface HomeProps {
  isLoggedIn: boolean;
  username: string;
  taskCount: number;
  contentSetCount: number;
}

export const Home: React.FC<HomeProps> = function({ isLoggedIn, username, taskCount, contentSetCount }) {
    const showDashboard = isLoggedIn && (taskCount > 0 || contentSetCount > 0);

    return (
      <div>
					<hr />
          {showDashboard ? (
            <DashboardSummary
              username={username}
              taskCount={taskCount}
              contentSetCount={contentSetCount}
            />
          ) : (
            <>
              <h3>About</h3>
              <p>This is the teachers' section.  To make a a set of images click on the 'Content' button.  That page can also be used to view and edit sets of images that you have previously created.  Click on 'Homework Tasks' to create tasks that monitor student completion.  Student outcomes will appear on the same page.  You can also get links to share the games or get code to embed the games into your site or blog.</p>
              <p>You can still use the old version <a href='https://www.gamestolearnenglish.com/teachers/'>here</a>.</p>
              <p>You can send a message through the <a href='https://www.gamestolearnenglish.com/pages/contact/' target='_blank' rel="noreferrer"  className='teachers-link-nounderline'>contact page</a>.</p>
            </>
          )}
        </div>
    );
};
